import { Component, Input, OnInit } from '@angular/core';
import { ChartConfiguration, ChartType } from 'chart.js';
import { DevicesService } from 'src/app/views/main/superadmin/services/devices.service';

@Component({
  selector: 'app-graph-battery-coverage',
  templateUrl: './graph-battery-coverage.component.html',
  styleUrls: ['./graph-battery-coverage.component.scss'],
  standalone: false
})
export class GraphBatteryCoverageComponent implements OnInit {
  @Input() device!: any;

  // Usamos 'line' para los tres
  public chartType: ChartType = 'line';

  // Opciones comunes: ocultar puntos, suavizar líneas
  private commonLineOptions: ChartConfiguration['options'] = {
    responsive: true,
    plugins: { 
      legend: { display: false }},
   
      elements: { point: { radius: 0 } },  // oculta los puntos
      interaction: { mode: 'index', intersect: false },
    };

    public batteryOptions: ChartConfiguration['options'] = {
      ...this.commonLineOptions,
      scales: {
        y: {
          position: 'right',
          // min: 0,
          // max: 10000, // mV
          title: { display: true, text: 'Nivel de Batería (mV)' },
          ticks: { stepSize: 1000 }
        },
        x: { ticks: { maxRotation: 45, minRotation: 45 } }
      }
    };

    public coverageOptions: ChartConfiguration['options'] = {
      ...this.commonLineOptions,
      scales: {
        y: {
          position: 'right',
          // min: -120,
          // max: 0,
          reverse: true,
          title: { display: true, text: 'RSSI (dBm)' },
          ticks: { stepSize: 20 }
        },
        x: { ticks: { maxRotation: 45, minRotation: 45 } }
      }
    };

    public errorOptions: ChartConfiguration['options'] = {
      ...this.commonLineOptions,
      scales: {
        y: {
          beginAtZero: true,
          title: { display: true, text: 'ID de Error' },
          ticks: { stepSize: 1 }
        },
        x: { ticks: { maxRotation: 45, minRotation: 45 } }
      }
    };

    public batteryChartData: ChartConfiguration['data'] = { labels: [], datasets: [] };
    public coverageChartData: ChartConfiguration['data'] = { labels: [], datasets: [] };
    public errorChartData: ChartConfiguration['data'] = { labels: [], datasets: [] };

    constructor(private deviceService: DevicesService) { }

  ngOnInit(): void {
      if (this.device?.id) this.loadDeviceData();
      else console.warn('⚠️ No device input received.');
    }

  private loadDeviceData(): void {
      const endDate = new Date().toISOString();
      const startDate = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString();

      this.deviceService.getDiagnostic(this.device.id, startDate, endDate)
        .subscribe({
          next: (data: any[]) => {
            const labels = data.map(d =>
              new Date(d.date).toLocaleString('es-ES', {
                day: '2-digit', month: 'short', hour: '2-digit'
              })
            );
            const batteryData = data.map(d => d.vBus);
            const coverageData = data.map(d => d.mConf?.rssiLV ?? null);
            const errorData = data.map(d => d.errorId ?? 0);

            this.batteryChartData = {
              labels,
              datasets: [{
                label: 'Batería',
                data: batteryData,
                borderColor: '#66BB6A',
                fill: false,
                tension: 0.3
              }]
            };

            this.coverageChartData = {
              labels,
              datasets: [{
                label: 'Cobertura',
                data: coverageData,
                borderColor: '#29B6F6',
                fill: false,
                tension: 0.3
              }]
            };

            this.errorChartData = {
              labels,
              datasets: [{
                label: 'Errores',
                data: errorData,
                borderColor: '#EF5350',
                fill: false,
                tension: 0.3
              }]
            };
          },
          error: err => console.error('Error loading device data:', err)
        });
    }
  }
